module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan cervical.3adadc10.svg";